import React from 'react';
import {string, number, object, oneOfType} from "prop-types";

// Heroicons v2 (outline) — the icon set the Figma filter bar uses. The app has no
// heroicons dependency, so the small set we need is provided here as one reusable
// component (imported, not inlined at each call site). Icons inherit the current
// text color and accept size/className/style.
const HeroIcon = ({ path, size = 16, strokeWidth = 1.5, className, style, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
    stroke="currentColor"
    width={size}
    height={size}
    className={className}
    style={style}
    {...rest}>
    <path strokeLinecap="round" strokeLinejoin="round" d={path} />
  </svg>
);

HeroIcon.propTypes = {
    path: string,
    size: oneOfType([string, number]),
    strokeWidth: oneOfType([string, number]),
    className: string,
    style: object
};

export const MagnifyingGlassIcon = (props) => (
  <HeroIcon {...props} path="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
);

export const ClockIcon = (props) => (
  <HeroIcon {...props} path="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
);

export const CalendarIcon = (props) => (
  <HeroIcon
    {...props}
    path="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
  />
);

export const ChevronDownIcon = (props) => (
  <HeroIcon {...props} path="m19.5 8.25-7.5 7.5-7.5-7.5" />
);

// Heroicons v2 (outline) map — used for the route distance in the card header.
export const MapIcon = (props) => (
  <HeroIcon
    {...props}
    path="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
  />
);

// Outline hourglass (heroicons has none) drawn in the same 24px stroke style as
// the others, for the route duration in the card header. Top/bottom bars plus
// two pinched sides meeting at the neck.
export const HourglassIcon = (props) => (
  <HeroIcon
    {...props}
    path="M5 3h14M5 21h14M6.5 3v2.5c0 3 2.5 4.5 4.5 5.5-2 1-4.5 2.5-4.5 5.5V21M17.5 3v2.5c0 3-2.5 4.5-4.5 5.5 2 1 4.5 2.5 4.5 5.5V21"
  />
);

export default HeroIcon;
